import { gql } from '@apollo/client';

export const COUNTRIES_PAGE_QUERY = gql`
  query countries(
    $limit: Int!
    $offset: Int!
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    countries(
      limit: $limit
      offset: $offset
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      hasDraft
      currentVersion {
        deletedAt
        code2
        code3
        createdById
        id
        name
        regionId
        status
        updatedById
        version
      }
    }
    countriesPageInfo(
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const COUNTRIES_QUERY = gql`
  query countries($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    countries(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      hasDraft
      currentVersion {
        code2
        code3
        createdById
        id
        name
        regionId
        status
        updatedById
        version
        deletedAt
      }
    }
  }
`;

export const COUNTRY_QUERY = gql`
  query country($id: Int!) {
    country(id: $id) {
      id
      currentVersion {
        deletedAt
        code2
        code3
        createdById
        id
        name
        regionId
        status
        updatedById
        version
      }
    }
  }
`;

export const COUNTRY_VERSIONS_QUERY = gql`
  query countryVersions($limit: Int, $offset: Int, $countryId: Int!) {
    countryVersions(limit: $limit, offset: $offset, countryId: $countryId) {
      deletedAt
      code2
      code3
      countryId
      createdAt
      createdById
      id
      name
      regionId
      status
      updatedAt
      updatedById
      version
    }
  }
`;
